import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import { IQuery } from "@types";
import React, { FunctionComponent, useCallback, useContext, useMemo } from "react";
import { ContextDatasection, hasValue, PillConfiguration, PillInput, PillOption } from "uxp/components";

interface DEPillInputProps {
    query: IQuery,
    value: string,
    onChange: (val: string) => void
}
export const DEPillInput: FunctionComponent<DEPillInputProps> = ({ query, value, onChange }) => {

    const context = useContext(QueryBuilderContext);

    const deContext: ContextDatasection = {
        label: 'Data Explorer Parameters',
        fields: (query?.params || []).map(p => ({
            label: p.name,
            value: `$.deparams.${p.name}`,
            formatters: (hasValue(p?.type)) ? [p.type] : undefined
        }))
    }

    const deConfiguration: PillConfiguration = {
        deparams: {
            valueIndex: 0,
            renderValue(value, allFields) {
                const field = allFields.find(f => f?.value == value)
                if (field) return field.label
                return value
            },
            icon: 'fas sliders-h',
            backgroundColor: '#52A1F2',
            textColor: '#FFF'
        }
    }

    const externalSections = (context?.externalContextDataSections || [])?.filter(es => !!es)
    const sections = [deContext, ...externalSections]
    const configurations = { ...context?.externalPillConfiguration || {}, ...deConfiguration }

    console.log('externalcontext', sections, deContext)

    return <PillInput
        value={value || ''}
        onChange={onChange}
        contextDataSections={sections}
        pillConfiguration={configurations}
    />
}